"use strict";
import { ExternalLink } from "ui/src/components/icons";
export const useTabsContent = (props) => {
  return [
    {
      title: "Liquidity",
      href: `https://liquidity.flow.com/`,
      icon: <ExternalLink size="$icon.16" color="$neutral2" />,
      internal: false
    },
    {
      title: "Bridge",
      href: `https://bridge.flow.com`,
      icon: <ExternalLink size="$icon.16" color="$neutral2" />,
      internal: false
    }
  ];
};
